__turbopack_context__.v({
  "automotive": "tab-container-module__lHQKoq__automotive",
  "automotive1": "tab-container-module__lHQKoq__automotive1",
  "automotive2": "tab-container-module__lHQKoq__automotive2",
  "automotive3": "tab-container-module__lHQKoq__automotive3",
  "horizontalTab": "tab-container-module__lHQKoq__horizontalTab",
  "horizontalTabWrapper": "tab-container-module__lHQKoq__horizontalTabWrapper",
  "resourceTitle": "tab-container-module__lHQKoq__resourceTitle",
  "tab": "tab-container-module__lHQKoq__tab",
  "tabContainer": "tab-container-module__lHQKoq__tabContainer",
  "tabsFlexible": "tab-container-module__lHQKoq__tabsFlexible",
});
